import {ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation} from '@angular/core';
import {DotRouteService} from '@ng-dot/route';

@Component({
	standalone: false,
	selector       : 'app-dls',
	template       : `
		<ng-container *ngIf="icons; else displayTextOnly">
			<dl *ngFor="let item of items; let index = index" (click)="click(index)">
				<dt>
					<i class="icon icon-{{icons[index]}}"></i>
					{{item.title}}
				</dt>
				<dd>{{item.description}}</dd>
			</dl>
		</ng-container>
		<ng-template #displayTextOnly>
			<dl *ngFor="let item of items; let index = index" (click)="click(index)">
				<dt>{{item.title}}</dt>
				<dd>{{item.description}}</dd>
			</dl>
		</ng-template>
	`,
	encapsulation  : ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DlsComponent {
	constructor(protected _route: DotRouteService) {
	}

	@Input() items: Array<{
		title: string,
		description: string
	}> = [];

	@Input() links: string[];

	@Input() icons: string[];

	click(index: number) {
		const {links} = this;
		if (links) {
			const link = links[index];
			if (link) {
				this._route.move$(link);
			}
		}
	}
}
